var _path, _ellipse, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcLockImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 296,
    height: 121,
    viewBox: "0 0 296 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1874_29372)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M224.307 58.1573C223.618 76.5232 214.133 92.0992 198.188 101.65C166.5 120.628 111.181 123.651 67.9739 113.192C67.3195 113.036 66.6845 112.876 66.0464 112.695C65.9658 112.684 65.882 112.65 65.8014 112.639C59.342 110.972 53.159 108.882 47.3235 106.314C37.7811 102.12 29.2157 96.7261 22.138 89.9697C21.8424 89.6949 21.5661 89.4173 21.2899 89.1398C14.5184 82.4533 9.14699 74.4844 5.6957 65.1372C5.43762 64.4276 5.20203 63.7374 4.96645 63.0472C-4.32987 34.5176 12.2478 7.58645 41.517 6.35541C68.2912 5.22731 76.5487 15.7283 97.7011 21.5411C118.85 27.3319 144.793 19.7401 166.232 15.9503C173.577 14.6441 181.393 15.2833 186.54 16.0499C205.177 18.8717 225.328 30.9412 224.307 58.1573Z",
    fill: "#4182EC"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.3,
    cx: 120,
    cy: 111.5,
    rx: 72,
    ry: 4,
    fill: "url(#paint0_radial_1874_29372)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M115.975 5.5C108.584 12.539 89.6625 19.6433 67.6026 34.7176C67.6026 34.7176 68.9808 85.6566 115.975 113.5V5.5Z",
    fill: "url(#paint1_linear_1874_29372)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M115.976 5.5C123.367 12.539 142.289 19.6433 164.349 34.7176C164.349 34.7176 162.97 85.6566 115.976 113.5V5.5Z",
    fill: "url(#paint2_linear_1874_29372)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M115.975 9.83691C107.052 16.1634 91.592 22.1913 71.1501 36.1599C71.1501 36.1599 72.4271 83.363 115.975 109.164C159.523 83.363 160.8 36.1599 160.8 36.1599C140.358 22.1913 124.967 16.1634 115.975 9.83691Z",
    fill: "url(#paint3_linear_1874_29372)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M153.162 31.1445C121.979 40.5791 98.1674 67.9837 87.3748 82.4362C94.8166 93.349 104.584 102.477 115.975 109.163C159.523 83.3623 160.8 36.1592 160.8 36.1592C158.169 34.3613 155.623 32.6969 153.162 31.1445Z",
    fill: "url(#paint4_linear_1874_29372)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.3904 63.9797C71.1616 68.3999 68.1403 72.6126 66.5226 76.3427C64.9008 80.0821 64.7483 83.1856 65.9779 85.5494C67.1817 87.8636 69.7257 89.4999 73.5809 90.3364C77.4285 91.1712 82.4353 91.1714 88.2871 90.3367C95.6364 89.2884 104.229 86.9362 113.371 83.3714C109.337 81.6551 105.229 79.7188 101.1 77.571C85.7509 69.5869 73.5044 60.1714 65.5407 51.2282C61.56 46.758 58.6237 42.377 56.9168 38.3242C55.2137 34.2803 54.6979 30.4709 55.712 27.2175C57.2553 22.2659 62.5918 20.8214 67.5749 21.1682C70.1238 21.3456 72.7269 21.9879 74.9927 22.9664C77.2453 23.9393 79.2429 25.2787 80.4983 26.9037L78.9157 28.1264C77.9397 26.8633 76.2722 25.6976 74.1998 24.8025C72.1406 23.9132 69.7586 23.325 67.436 23.1633C62.676 22.8321 58.7238 24.2757 57.6214 27.8126C56.7988 30.4517 57.1602 33.7493 58.76 37.5479C60.3561 41.3376 63.1485 45.5345 67.0343 49.8982C74.8035 58.6229 86.8407 67.8994 102.023 75.7967C106.75 78.2559 111.444 80.431 116.019 82.311C120.595 80.431 125.288 78.2558 130.016 75.7966L130.042 75.783L130.069 75.771C143.134 69.9261 154.369 60.4483 162.226 51.1316C166.153 46.4751 169.219 41.8794 171.244 37.8251C173.287 33.7351 174.206 30.3218 174.011 27.9864C173.824 25.7487 172.953 24.2767 171.721 23.3559C170.463 22.4151 168.708 21.9618 166.621 22.0207C162.433 22.1389 157.252 24.3196 153.247 27.929L151.908 26.4433C156.199 22.5759 161.819 20.1554 166.565 20.0215C168.945 19.9543 171.19 20.4621 172.919 21.7539C174.674 23.0658 175.777 25.0978 176.004 27.8198C176.246 30.7124 175.125 34.5313 173.033 38.7187C170.924 42.9418 167.763 47.6688 163.755 52.421C155.748 61.9157 144.291 71.5936 130.913 77.5845C126.793 79.7269 122.693 81.6587 118.667 83.3714C127.809 86.9362 136.402 89.2884 143.751 90.3367C149.603 91.1715 154.61 91.1712 158.458 90.3364C162.313 89.4999 164.857 87.8636 166.061 85.5494C167.29 83.1856 167.138 80.0821 165.516 76.3427C163.898 72.6126 160.877 68.3999 156.648 63.9797L158.093 62.5972C162.412 67.1109 165.604 71.5193 167.351 75.547C169.094 79.5652 169.456 83.356 167.835 86.4724C166.248 89.5233 163.039 91.3888 158.882 92.2909C154.716 93.1947 149.45 93.1698 143.469 92.3167C135.429 91.1698 125.995 88.5108 116.019 84.4709C106.044 88.5108 96.61 91.1697 88.5695 92.3167C82.5887 93.1698 77.3222 93.1947 73.1568 92.2909C68.9991 91.3888 65.7906 89.5232 64.2036 86.4724C62.5825 83.356 62.945 79.5652 64.6877 75.547C66.4344 71.5193 69.6269 67.1109 73.9452 62.5972L75.3904 63.9797Z",
    fill: "url(#paint5_linear_1874_29372)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1874_29372)"
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M130.818 59.714H101.601C100.957 59.714 100.34 59.4582 99.8844 59.0028C99.4291 58.5475 99.1733 57.93 99.1732 57.286V43.5245C99.1732 39.0062 100.968 34.673 104.163 31.4781C107.358 28.2832 111.691 26.4883 116.209 26.4883C120.728 26.4883 125.061 28.2832 128.256 31.4781C131.451 34.673 133.246 39.0062 133.246 43.5245V57.286C133.246 57.93 132.99 58.5475 132.535 59.0029C132.079 59.4582 131.462 59.714 130.818 59.714ZM104.029 54.8581H128.39V43.5245C128.39 40.2941 127.107 37.196 124.822 34.9117C122.538 32.6275 119.44 31.3442 116.209 31.3442C112.979 31.3442 109.881 32.6275 107.597 34.9117C105.312 37.196 104.029 40.2941 104.029 43.5245V54.8581Z",
    fill: "url(#paint6_linear_1874_29372)",
    stroke: "url(#paint7_linear_1874_29372)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M98.5618 52.7402H133.428C134.284 52.7402 134.979 53.4346 134.979 54.2912V83.0044C134.979 83.861 134.284 84.5554 133.428 84.5554H98.5618C97.7052 84.5554 97.0109 83.861 97.0109 83.0044V54.2912C97.0109 53.4346 97.7052 52.7402 98.5618 52.7402Z",
    fill: "url(#paint8_linear_1874_29372)",
    stroke: "url(#paint9_linear_1874_29372)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M121.121 65.5109C121.121 64.6153 120.881 63.7357 120.425 62.9617C119.969 62.1877 119.313 61.547 118.525 61.1049C117.737 60.6627 116.844 60.4349 115.938 60.4446C115.032 60.4544 114.145 60.7013 113.366 61.1603C112.588 61.6192 111.947 62.2739 111.508 63.0574C111.069 63.841 110.848 64.7256 110.868 65.621C110.887 66.5164 111.147 67.3907 111.62 68.1549C112.092 68.919 112.762 69.5456 113.559 69.9709L112.698 78.9029H119.29L118.429 69.9709C119.243 69.5369 119.923 68.8931 120.397 68.1079C120.871 67.3226 121.122 66.4252 121.121 65.5109Z",
    fill: "url(#paint10_linear_1874_29372)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M121.121 65.5109C121.121 64.6153 120.881 63.7357 120.425 62.9617C119.969 62.1877 119.313 61.547 118.525 61.1049C117.737 60.6627 116.844 60.4349 115.938 60.4446C115.032 60.4544 114.145 60.7013 113.366 61.1603C112.588 61.6192 111.947 62.2739 111.508 63.0574C111.069 63.841 110.848 64.7256 110.868 65.621C110.887 66.5164 111.147 67.3907 111.62 68.1549C112.092 68.919 112.762 69.5456 113.559 69.9709L112.698 78.9029H119.29L118.429 69.9709C119.243 69.5369 119.923 68.8931 120.397 68.1079C120.871 67.3226 121.122 66.4252 121.121 65.5109Z",
    stroke: "url(#paint11_linear_1874_29372)",
    strokeOpacity: 0.7,
    strokeWidth: 0.485591,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      mixBlendMode: "overlay"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1874_29372)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 124.088,
    y: 36.5,
    width: 65.8242,
    height: 19.9824,
    rx: 4.2126,
    fill: "url(#paint12_linear_1874_29372)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.588,
    y: 37,
    width: 64.8242,
    height: 18.9824,
    rx: 3.7126,
    stroke: "url(#paint13_linear_1874_29372)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 133.491,
    cy: 46.4911,
    r: 3.5263,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 133.491,
    cy: 46.4911,
    r: 3.5263,
    fill: "url(#paint14_linear_1874_29372)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 133.491,
    cy: 46.4911,
    r: 3.5263,
    fill: "url(#paint15_radial_1874_29372)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 142.895,
    cy: 46.4911,
    r: 3.5263,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 142.895,
    cy: 46.4911,
    r: 3.5263,
    fill: "url(#paint16_linear_1874_29372)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 142.895,
    cy: 46.4911,
    r: 3.5263,
    fill: "url(#paint17_radial_1874_29372)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 152.298,
    cy: 46.4911,
    r: 3.5263,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 152.298,
    cy: 46.4911,
    r: 3.5263,
    fill: "url(#paint18_linear_1874_29372)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 152.298,
    cy: 46.4911,
    r: 3.5263,
    fill: "url(#paint19_radial_1874_29372)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161.702,
    cy: 46.4911,
    r: 3.5263,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161.702,
    cy: 46.4911,
    r: 3.5263,
    fill: "url(#paint20_linear_1874_29372)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161.702,
    cy: 46.4911,
    r: 3.5263,
    fill: "url(#paint21_radial_1874_29372)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 171.105,
    cy: 46.4911,
    r: 3.5263,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 171.105,
    cy: 46.4911,
    r: 3.5263,
    fill: "url(#paint22_linear_1874_29372)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 171.105,
    cy: 46.4911,
    r: 3.5263,
    fill: "url(#paint23_radial_1874_29372)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.508,
    cy: 46.4911,
    r: 3.5263,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.508,
    cy: 46.4911,
    r: 3.5263,
    fill: "url(#paint24_linear_1874_29372)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.508,
    cy: 46.4911,
    r: 3.5263,
    fill: "url(#paint25_radial_1874_29372)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1874_29372",
    x: 92.6132,
    y: 25.9883,
    width: 46.7633,
    height: 66.8626,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.89763
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.94882
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.21 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1874_29372"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1874_29372",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1874_29372",
    x: 121.983,
    y: 35.4476,
    width: 74.2433,
    height: 28.4016,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.10478,
    dy: 3.15718
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.10478
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.130752 0 0 0 0 0.15853 0 0 0 0 0.219642 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1874_29372"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1874_29372",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1874_29372",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(120 111.5) rotate(90) scale(4 72)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7988B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864583,
    stopColor: "#7988B1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1874_29372",
    x1: 114.245,
    y1: 113.376,
    x2: 80.8764,
    y2: 27.4415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0767182,
    stopColor: "#448D7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666476,
    stopColor: "#73B599"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADF7C2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1874_29372",
    x1: 176.392,
    y1: 78.1993,
    x2: 109.113,
    y2: -12.2583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003C30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.561878,
    stopColor: "#246A5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851096,
    stopColor: "#54A695"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1874_29372",
    x1: 155.933,
    y1: 80.6185,
    x2: 121.445,
    y2: 7.66183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#14554E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#2F7A72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#73B599"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1874_29372",
    x1: 150.009,
    y1: 123.929,
    x2: 84.3449,
    y2: 6.6723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.148171,
    stopColor: "#0B3531"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.579606,
    stopColor: "#73B599",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.970837,
    stopColor: "#ADF7C2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1874_29372",
    x1: 88.2556,
    y1: 104.212,
    x2: 90.8789,
    y2: -7.3154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7288CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.293969,
    stopColor: "#909FC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.642674,
    stopColor: "#B9C5EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.991093,
    stopColor: "#D5E0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1874_29372",
    x1: 97.5844,
    y1: 24.9971,
    x2: 140.3,
    y2: 42.3365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.250901,
    stopColor: "#E5ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7385B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1874_29372",
    x1: 116.209,
    y1: 26.1597,
    x2: 116.209,
    y2: 59.7142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDCEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1874_29372",
    x1: 94.6938,
    y1: 50.7675,
    x2: 141.299,
    y2: 72.6746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.250901,
    stopColor: "#E5ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7385B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1874_29372",
    x1: 118.287,
    y1: 85.132,
    x2: 118.287,
    y2: 53.4736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDCEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1874_29372",
    x1: 119.648,
    y1: 99.0707,
    x2: 96.1057,
    y2: 62.7609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#425892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.368422,
    stopColor: "#2E3D75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09143F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1874_29372",
    x1: 121.451,
    y1: 79.5645,
    x2: 122.42,
    y2: 61.4267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#091E59"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1874_29372",
    x1: 164.65,
    y1: 55.2245,
    x2: 157.245,
    y2: 29.9592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.164324,
    stopColor: "#122D82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.690489,
    stopColor: "#5473C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#709AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1874_29372",
    x1: 172.952,
    y1: 35.3295,
    x2: 169.51,
    y2: 58.266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DADDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1874_29372",
    x1: 134.311,
    y1: 49.5735,
    x2: 129.472,
    y2: 44.5617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.164324,
    stopColor: "#122D82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.690489,
    stopColor: "#5473C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#709AD8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_1874_29372",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(133.491 46.4911) rotate(45.0335) scale(7.48479 6.69013)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7385B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1874_29372",
    x1: 143.714,
    y1: 49.5735,
    x2: 138.876,
    y2: 44.5617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.164324,
    stopColor: "#122D82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.690489,
    stopColor: "#5473C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#709AD8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_1874_29372",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(142.895 46.4911) rotate(45.0335) scale(7.48479 6.69013)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7385B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1874_29372",
    x1: 153.118,
    y1: 49.5735,
    x2: 148.279,
    y2: 44.5617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.164324,
    stopColor: "#122D82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.690489,
    stopColor: "#5473C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#709AD8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_1874_29372",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(152.298 46.4911) rotate(45.0335) scale(7.48479 6.69013)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7385B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1874_29372",
    x1: 162.521,
    y1: 49.5735,
    x2: 157.683,
    y2: 44.5617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.164324,
    stopColor: "#122D82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.690489,
    stopColor: "#5473C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#709AD8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_1874_29372",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(161.702 46.4911) rotate(45.0335) scale(7.48479 6.69013)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7385B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1874_29372",
    x1: 171.925,
    y1: 49.5735,
    x2: 167.086,
    y2: 44.5617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.164324,
    stopColor: "#122D82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.690489,
    stopColor: "#5473C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#709AD8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_1874_29372",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(171.105 46.4911) rotate(45.0335) scale(7.48479 6.69013)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7385B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1874_29372",
    x1: 181.328,
    y1: 49.5735,
    x2: 176.489,
    y2: 44.5617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.164324,
    stopColor: "#122D82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.690489,
    stopColor: "#5473C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#709AD8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_1874_29372",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(180.508 46.4911) rotate(45.0335) scale(7.48479 6.69013)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7385B5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1874_29372"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 296,
    height: 120,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLockImage);
export default __webpack_public_path__ + "static/media/ic-lock-image.8b8953d710665c3322308827723ae539.svg";
export { ForwardRef as ReactComponent };